class ErrorUtils {
  extractErrorMessage(error) {
    const getLang = localStorage.getItem('setLangCode');
    if (error.response.status == 401 && getLang == 'FR') {
      return "Nom d'utilisateur ou mot de passe invalide";
    }
    return (error.response
      && error.response.data
      && error.response.data.message
      && error.response.data.message.split(':')[1])
      || error.message;
  }

  extractErrorHttpStatusCode(error) {
    return (error.response
      && error.response.status)
      || error.status;
  }

  extractErrorAppCode(error) {
    return (error.response
      && error.response.data
      && error.response.data.appCode)
      || error.appCode;
  }

  extractInfoFromError(error, propertyName) {
    return error.response
      && error.response.data
      && error.response.data.info
      && error.response.data.info[propertyName];
  }

  extractErrorBaseUrl(error) {
    return error.response
      && error.response.config
      && error.response.config.baseURL;
  }

  extractErrorPath(error) {
    return error.response
      && error.response.config
      && error.response.config.url;
  }
}

export default new ErrorUtils();
